<template>
    <Layout>
        <div class="bg-gray-50 py-12 md:py-20">
            <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div class="text-center mb-12 md:mb-16">
                    <h1 class="text-4xl sm:text-5xl font-extrabold text-[#00395a] tracking-tight">Support Our Cause</h1>
                    <p class="mt-4 text-lg sm:text-xl text-black max-w-3xl mx-auto">
                        <span class="font-semibold">"Charity sees the need, not the cause."</span> We humbly request your generous contributions towards Medical Aid, Education (School and College), and Financial Assistance for those in need. Tax deduction certificates under section 80G will be provided for eligible donations.
                    </p>
                    <p class="mt-3 text-md text-gray-700">
                        To donate, please contact the Mahajan office at <a href="tel:+919987240404" class="text-[#00395a] hover:underline font-medium">+91 99872 40404</a> or email us at <a href="mailto:secretary@sglm.in" class="text-[#00395a] hover:underline font-medium">secretary@sglm.in</a>.
                    </p>
                </div>

                <!-- Monetary Donations Section -->
                <div class="mb-16 md:mb-20 bg-white p-6 sm:p-8  ">
                    <h2 class="text-2xl sm:text-3xl font-bold text-[#00395a] mb-6 text-center md:text-left">Monetary Donations Received</h2>
                    <p class="text-black mb-6 text-center md:text-left text-lg">We are immensely thankful to all our donors who support and help us grow as a family.</p>
                    <div class="overflow-x-auto">
                        <table class="min-w-full divide-y divide-gray-300">
                            <thead class="bg-gray-100">
                                <tr>
                                    <th scope="col" class="px-6 py-3 text-left text-base font-medium text-[#00395a]uppercase tracking-wider">Sr. No.</th>
                                    <th scope="col" class="px-6 py-3 text-left text-base font-medium text-[#00395a] uppercase tracking-wider">Donor Name / Details</th>
                                    <th scope="col" class="px-6 py-3 text-left text-base font-medium text-[#00395a] uppercase tracking-wider">Amount (INR)</th>
                                </tr>
                            </thead>
                            <tbody class="bg-white divide-y divide-gray-200">
                                <tr v-if="donations.length === 0">
                                    <td colspan="3" class="px-6 py-4 whitespace-nowrap text-center text-gray-500">No monetary donations to display at the moment.</td>
                                </tr>
                                <tr v-for="(donation, index) in donations" :key="donation.id || index" class="hover:bg-gray-50 transition-colors">
                                    <td class="px-6 py-4 whitespace-nowrap text-lg text-black">{{ index + 1 }}</td>
                                    <td class="px-6 py-4 whitespace-nowrap text-lg text-black text-left">{{ donation.memberName }}</td>
                                    <td class="px-6 py-4 whitespace-nowrap text-lg text-black text-left">{{ donation.donationAmount }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <!-- Donations in Kind Section -->
                <div class="p-6 sm:p-8 ">
                    <h2 class="text-2xl sm:text-3xl font-bold text-[#00395a] mb-6 text-center md:text-left">Donations in Kind (Available for Rent)</h2>
                    <p class="text-black mb-8 text-center md:text-left text-lg">The following items, generously donated, are available for rent. Kindly contact the office for more details.</p>
                    
                    <div v-if="donationItems.length === 0" class="text-center text-gray-500 py-8">
                        <p>No items donated in kind to display at the moment.</p>
                    </div>
                    <div v-else class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
                        <div v-for="item in donationItems" :key="item.id || item.donationItem" class="bg-white  overflow-hidden hover:shadow-lg transition-shadow duration-300 flex flex-col">
                            <img :src="item.donationItemImage || defaultItemImage" class="w-full h-56 object-contain" :alt="item.donationItem">
                            <div class="p-4 flex flex-col flex-grow">
                                <h3 class="font-bold text-xl text-[#00395a] mb-1">{{ item.donationItem }} 
                                    <span v-if="item.donationQuantity" class="text-sm text-gray-600">({{ item.donationQuantity }})</span>
                                </h3>
                                <p class="text-sm text-gray-600 mb-2">
                                    <span class="font-medium">Donated by:</span> {{ item.donatedBy }}
                                </p>
                                <p v-if="item.caption" class="text-gray-700 text-sm mt-auto pt-2">
                                    {{ item.caption }}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>
<script>
import Layout from './../layouts/LayoutView.vue'
import axiosInstance from '@/utils/axiosInstance';
import defaultPlaceholder from '@/assets/placeholder-image.jpeg'; // Import a default placeholder

export default {
  components: {
    Layout
  },
  data() {
    return {
        donations: [],
        donationItems: [],
        defaultItemImage: defaultPlaceholder,
    };
  },
  created() {
    this.fetchDonations();
  },
  methods: {
    log(){
        // console.log(msg); // Keep for debugging if needed, but can be removed for production
     },
    async fetchDonations() {
        try {
            const response = await axiosInstance.get('donation-page?populate[donationsInKind][populate]=donationItemImage&populate[moneyDonation][populate]=*')
            const responseAttributes = response.data.data.attributes;
            this.donations = responseAttributes.moneyDonation || [];
            this.donationItems = responseAttributes.donationsInKind.map(item => ({
                donationItemImage: item.donationItemImage?.data?.attributes?.url || ''
            }));
            // console.log(this.donations) // Keep for debugging if needed
        } catch (error) {
            console.error("Failed to fetch donations:", error);
        }
    }
  }
}
</script>
